import { Heading } from '@app/app/_components/Heading/Heading';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { Tag } from '@app/app/_components/Tag/Tag';
import { formatEuroValue } from '@app/infrastructure/application/formatEuroValue';
import { splitNumber } from '@app/lib/split-number/splitNumber';
import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

interface Props {
    title: string;
    price: number;
    originalPrice?: number;
    showFromPrefix?: boolean;
    discountPercentage?: number;
    discountLabel?: string;
    insuranceDuration: string;
    description?: ReactNode;
}

export function PremiumCard({
    title,
    price,
    originalPrice,
    showFromPrefix = false,
    discountPercentage,
    discountLabel,
    insuranceDuration,
    description,
}: Props) {
    const t = useTranslations();
    const hasDiscount = originalPrice && originalPrice > price;
    const splittedPrice = splitNumber(price);

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-row flex-wrap gap-3">
                <Heading level="h3">{title}</Heading>
                {hasDiscount && (discountPercentage || discountLabel) && (
                    <Tag>{`${discountLabel ? discountLabel : t('eshop.transport.saveTo')} ${discountPercentage ? discountPercentage.toFixed(0) + '%' : ''}`}</Tag>
                )}
            </div>
            <div className="flex flex-row items-baseline gap-2">
                <div className="flex flex-col items-start">
                    {hasDiscount && (
                        <Paragraph isGray size="tiny" className="line-through">
                            {showFromPrefix ? `${t('general.from')} ` : ''}
                            {formatEuroValue(originalPrice, true)}
                        </Paragraph>
                    )}
                    {showFromPrefix && !hasDiscount && <Paragraph>{t('general.from')}</Paragraph>}
                    <div className="flex flex-row items-start gap-1">
                        <Paragraph isBold size="medium">
                            {splittedPrice.integerPart}
                        </Paragraph>
                        <Paragraph isBold size="tiny">
                            {splittedPrice.fractionalPart}
                        </Paragraph>
                        <Paragraph isBold size="medium">
                            €
                        </Paragraph>
                        <Paragraph className="self-center" isGray>
                            {`/ ${insuranceDuration} ${t('general.months')}`}
                        </Paragraph>
                    </div>
                </div>
            </div>
            {description && (
                <Paragraph isGray size="small">
                    {description}
                </Paragraph>
            )}
        </div>
    );
}
